import React, { useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';

const AuthProtected = ({ children }) => {
  const { user, token, initialLoading, signOut } = useContext(AuthContext);

  useEffect(() => {
    if (!initialLoading && user && token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else if (!initialLoading && (!user || !token)) {
      console.log('No user or token, signing out');
      signOut();
    }
  }, [user, token, initialLoading, signOut]);

  if (initialLoading) {
    return <div>در حال بارگذاری...</div>;
  }

  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AuthProtected;